import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";
import {PlgSearchModel} from "../plg-search.model";
import {PlgSearchPageComponent} from "../plg-search-page/plg-search-page.component";

@Component({
    selector: "wbo-plg-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(PlgSearchModel),
        registerSearchControl(PlgMultiSelectSearchControlComponent)
    ]
})
export class PlgMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<PlgSearchModel> {
    constructor(model: PlgSearchModel, injector: Injector) {
        super(model, injector, "plgId", "name");

        this.extendedSearchComponent = PlgSearchPageComponent;
    }
}
